import React from 'react';

const DocumentTypeModal = ({ isOpen, onClose, onSelect, canConvert = true }) => {
  if (!isOpen) return null;

  const handleSelect = (type) => {
    if (onSelect) onSelect(type);
  };

  return (
    <div
      className="fixed inset-0 z-[1100] flex items-start justify-center bg-black/50 px-4 py-6 overflow-y-auto"
      onClick={() => onClose(false)}
    >
      <div
        className="bg-white w-full max-w-md rounded-2xl shadow-2xl border border-gray-100 overflow-hidden max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between px-6 py-4 border-b border-gray-100 bg-gray-50">
          <div>
            <p className="text-xs uppercase tracking-wide text-gray-500">Documento</p>
            <h2 className="text-lg font-semibold text-gray-900">Selecciona el tipo</h2>
            <p className="text-xs text-gray-500 mt-1">
            Elige &quot;Boleta&quot; para una venta detalle sin cliente, &quot;Factura&quot; para asociar
            un cliente, o convierte la venta a cotización.
            </p>
          </div>
          <button
            onClick={() => onClose(false)}
            className="text-gray-600 hover:text-gray-900 bg-white border border-gray-200 rounded-full w-9 h-9 flex items-center justify-center"
          >
            ✕
          </button>
        </div>
        <div className="p-6 flex flex-col gap-3">
          <button
            className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            onClick={() => handleSelect('boleta')}
          >
            Boleta (detalle sin cliente)
          </button>
          <button
            className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
            onClick={() => handleSelect('factura')}
          >
            Factura (requiere cliente)
          </button>
          {canConvert && (
            <button
              className="w-full px-4 py-3 bg-amber-500 text-white rounded-lg hover:bg-amber-600"
              onClick={() => handleSelect('quotation')}
            >
              Convertir a cotización
            </button>
          )}
          <button
            className="w-full px-4 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
            onClick={() => onClose(false)}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentTypeModal;
